module.exports = __webpack_public_path__ + "assets/img/video-v.81da7dd2.png";